import { Formik } from "formik";
import React, { useState } from "react";
import { useEffect } from "react";
import { Button, Col, Form, Row, Alert } from "react-bootstrap";
import { CREATE_DATA_PROPERTY } from "../../../../queries";
import { hasErrorCode, getErrorMessage } from "../../../../utils/errorUtils";

// Interface with parent
//
/*
interface DataProperties {
    shouldRefreshProperties: Function
}
*/

const RegisterPropertiesForm = (props: any) => {
    const [dataOptions, setDataOptions] = useState<any>(null);
    const [showSuccess, setShowSuccess] = useState<any>(false);
    const [showFail, setShowFail] = useState<any>(false);
    
    useEffect(() => {
        (async function fetchData() { // KEEP this logic for now, might use for getting options from DB
            setDataOptions("none"/*resultRoles.data.syncarto_app_role*/);
        })();
    }, []);

    /* SCHEMA 
        id - smallint, primary key, unique, default: nextval('syncarto_dw.property_id_seq'::regclass)
        category_id - smallint, unique, nullable
        name - character varying, nullable
        shortcode - character varying, nullable
        unit_id - smallint, unique, nullable
        org_id - uuid, unique, nullable
        type_id - integer, unique, nullable
    */
    const createSource = (sourceData:any) => {
        //console.log("createSource sourceData", sourceData);
        //console.log("createSource props", props);
        let category_value:any = parseInt(sourceData.category_id);
        if (isNaN(category_value)){
            category_value = null;
        }        
        let unit_value:any = parseInt(sourceData.unit_id);
        if (isNaN(unit_value)){
            unit_value = null;
        }        
        let type_value:any = parseInt(sourceData.type_id);
        if (isNaN(type_value)){
            type_value = null;
        }
        var data = {
            name: sourceData.name,
            shortcode: sourceData.shortcode,
            category_id: category_value,
            unit_id: unit_value,
            type_id: type_value,
            org_id: props.orgId,
        };
        console.log("createSource data", data);
        return props.client.mutate({
            mutation: CREATE_DATA_PROPERTY,
            variables: data,
            optimisticResponse: null
        });
    }


    if(dataOptions == null) {
        return (
            <div>Loading...</div>
        )
    }

    const validate = (values:any) => {
        var errors: {[k: string]: any} = {};

        if (values.name === "") {
            errors.name = 'Required';
        }

        if (values.shortcode === "") {
            errors.shortcode = 'Required';
        }

        return errors;
      };

    return (
        <Formik 
            initialValues= {{ 
                name: '',
                shortcode: '',
                category_id: '', // null
                unit_id: '', // null
                type_id: '', // null
            }}
            validateOnChange={false}
            validateOnBlur={false}
            validate={validate}
            onSubmit={async (values, {setSubmitting, resetForm}) => {
                setSubmitting(true);
                
                console.log("submitting...");

                try {
                    let sourceData = {
                        name: values.name,
                        shortcode: values.shortcode,
                        category_id: values.category_id, // null
                        unit_id: values.unit_id, // null
                        type_id: values.type_id, // null
                    };
                    console.log("sourceData", sourceData)
    
                    await createSource({...sourceData});

                    setShowSuccess(true);

                    setTimeout(() => {
                        const { shouldRefreshProperties } = props;
                        shouldRefreshProperties();
                    },500);  

                    setTimeout(() => {
                        setShowSuccess(false);
                    },1500);

                    resetForm();
                } catch(e) {
                    console.error(e);
                    if (hasErrorCode(e)) {
                        alert(getErrorMessage(e));
                    }
                    setShowFail(true);
                    setTimeout(() => {
                        setShowFail(false);
                    },1500);
                }
                setSubmitting(false);
            }}
        >
            {({
                values,
                errors,
                handleChange,
                handleBlur,
                handleSubmit,
                isSubmitting,
            }) => (
                <>
                <h4>Create Property</h4>  
                <div style={{marginTop: "10px", padding: "1em"}}>
                    <Form noValidate onSubmit={handleSubmit} autoComplete="off">                   
                        <Form.Group as={Row} controlId="form_name">
                            <Form.Label column sm="3">
                                Name                    
                            </Form.Label>
                            <Col sm="9">
                                <Form.Control 
                                    type="text" 
                                    name="name"
                                    onChange={handleChange} 
                                    value={values.name}
                                    onBlur={handleBlur}
                                    isInvalid={!!errors.name}
                                /> 
                                <Form.Control.Feedback type="invalid">
                                    {errors.name}
                                </Form.Control.Feedback>
                            </Col>
                        </Form.Group>
                        <Form.Group as={Row} controlId="form_shortcode">
                            <Form.Label column sm="3">
                                Shortcode
                            </Form.Label>
                            <Col sm="9">
                                <Form.Control 
                                    type="text" 
                                    name="shortcode"
                                    onChange={handleChange} 
                                    value={values.shortcode}
                                    onBlur={handleBlur}
                                    isInvalid={!!errors.shortcode}
                                />                                
                                <Form.Control.Feedback type="invalid">
                                    {errors.shortcode}
                                </Form.Control.Feedback>
                            </Col>
                        </Form.Group>
                        <Form.Group as={Row} controlId="form_category_id">
                            <Form.Label column sm="3">
                                Category
                            </Form.Label>
                            <Col sm="9">
                                <Form.Control
                                    as="select"
                                    name="category_id"
                                    onChange={handleChange}
                                    value={values.category_id}
                                    onBlur={handleBlur}
                                    isInvalid={!!errors.category_id}
                                >
                                    {
                                         props.formOptions.optionsFor_property_category.map((opt: any) => {
                                            return (
                                                <option key={opt.id} value={opt.id}>{opt.name}</option>
                                            );
                                        })
                                    }
                                </Form.Control>                                
                                <Form.Control.Feedback type="invalid">
                                    {errors.category_id}
                                </Form.Control.Feedback>   
                            </Col>
                        </Form.Group>
                        <Form.Group as={Row} controlId="form_type_id">
                            <Form.Label column sm="3">
                               Type
                            </Form.Label>
                            <Col sm="9">
                                <Form.Control
                                    as="select"
                                    name="type_id"
                                    onChange={handleChange}
                                    value={values.type_id}
                                    onBlur={handleBlur}
                                    isInvalid={!!errors.type_id}
                                >
                                    {
                                         props.formOptions.optionsFor_property_type.map((opt: any) => {
                                            return (
                                                <option key={opt.id} value={opt.id}>{opt.name}</option>
                                            );
                                        })
                                    }
                                </Form.Control>                                
                                <Form.Control.Feedback type="invalid">
                                    {errors.type_id}
                                </Form.Control.Feedback>   
                            </Col>
                        </Form.Group>
                        <Form.Group as={Row} controlId="form_unit_id">
                            <Form.Label column sm="3">
                               Units
                            </Form.Label>
                            <Col sm="9">
                                <Form.Control
                                    as="select"
                                    name="unit_id"
                                    onChange={handleChange}
                                    value={values.unit_id}
                                    onBlur={handleBlur}
                                    isInvalid={!!errors.unit_id}
                                >
                                    {
                                         props.formOptions.optionsFor_property_unit.map((opt: any) => {
                                            return (
                                                <option key={opt.id} value={opt.id}>{opt.name}{  opt.abbrv ? " (" + opt.abbrv + ")" : ""}</option>
                                            );
                                        })
                                    }
                                </Form.Control>                                
                                <Form.Control.Feedback type="invalid">
                                    {errors.unit_id}
                                </Form.Control.Feedback>   
                            </Col>
                        </Form.Group>
                    <Button
                        variant="primary"
                        type="submit"
                        disabled={isSubmitting}
                    >
                        Submit New Property
                    </Button>                    
                    <Alert show={showSuccess} variant="success" className="query-success-syncarto">
                        Source Created!
                    </Alert>                    
                    <Alert show={showFail} variant="warning" className="query-success-syncarto">
                        There was an issue with creating property!
                    </Alert>
                    </Form>
                </div>
                </>
            )}
        </Formik>   
    );
}

export default RegisterPropertiesForm;